import React, { Component } from 'react'
import { Card, Col, Form, Icon, Popconfirm, Row, Tooltip } from 'antd'
import _ from 'lodash'
import { dateFormat, dateVal, moneyInline, numVal, sessionItemByCode, strVal } from '../../../../../../modules/Utils'
import IconText from '../../../../../../elements/IconText'
import InvoiceForm from '../../../../../../components/Sales/Invoices/ViewInvoice/InvoiceForm'


class Overview extends Component {
  render() {
    const { invoice, isUpdatable, syncClient, syncOrder, centers } = this.props

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
    }
const hasOrder = _.get(invoice,'order')
    // const isOnlineOrder = _.get(invoice, 'order.isOnlineOrder')
    // const onlineClient = {
    //   client: {
    //     fn: `${strVal(invoice, 'cpo.billing.first_name')} ${strVal(invoice, 'cpo.billing.last_name')}`,
    //     address: _.get(invoice, 'order.delivery.notify.address'),
    //     taxRegistration: '',
    //   },
    //   payableRep: _.get(invoice, 'order.delivery.notify'),
    // }
    //
    // const client = isOnlineOrder ? onlineClient : invoice

    return (
      <Form layout={'horizontal'}>
        <Row>
          <Col span={8}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {strVal(invoice, 'company.fn')}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayout} label={'Invoice Type'}>
              {numVal(invoice, 'subTotal.net') > 0 ? (strVal(invoice, 'invoiceType').toUpperCase()) : 'CREDIT NOTE'}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...formItemLayout} label={'Invoice Date'}>
              {dateFormat(dateVal(invoice, 'date'))}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...formItemLayout} label={'Currency'}>
              {/*{`${sessionItemByCode('general_currency_dropdown', strVal(invoice, 'currency'))} - ${strVal(
                invoice,
                'currency'
              )}`}*/}
              {`${strVal(invoice, 'currency')}`}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...formItemLayout} label={'Invoice Amount'}>
              {moneyInline(numVal(invoice, 'subTotal.net'), strVal(invoice, 'currency'))}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...formItemLayout} label={'Paid Amount'}>
              {moneyInline(numVal(invoice, 'paid'), strVal(invoice, 'currency'))}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item {...formItemLayout} label={'Invoice Due'}>
              {dateFormat(dateVal(invoice, 'dueDate'))}
            </Form.Item>
          </Col>
        </Row>
        <InvoiceForm invoice={this.props.invoice} centers={centers} view={true} />
        <Row style={{ marginBottom: 10 }}>
          <Col span={hasOrder ? (11):(22)}>
            <Card
              title={
                <a href={`#/clients/${strVal(invoice, 'client.owner').replace('members/', '')}/`} target={'_blank'}>
                  <IconText type={'arrows-alt'} text={strVal(invoice, 'client.fn')} position={'left'} />
                  <Tooltip title={'Sync Client info latest changes'}>
                    {isUpdatable && (
                      <Popconfirm
                        title="Are you sure?"
                        placement="bottom"
                        onConfirm={syncClient}
                        okText="Yes"
                        cancelText="No">
                        <a style={{ float: 'right' }}>
                          <Icon type="sync" />
                        </a>
                      </Popconfirm>
                    )}
                  </Tooltip>
                </a>
              }>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Payable Contact'}>
                  {strVal(invoice, 'payableRep.fn')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Payable Email'}>
                  {strVal(invoice, 'payableRep.email.label')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Phone'}>
                  {strVal(invoice, 'payableRep.phone.label')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Address'}>
                  <span style={{ 'white-space': 'pre-line' }}>{strVal(invoice, 'client.address.label')}</span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Account'}>
                  {strVal(invoice, 'contract.code')}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Tax ID'}>
                  {strVal(invoice, 'client.taxRegistration')}
                </Form.Item>
              </Col>
            </Card>
          </Col>
          {hasOrder && (
          <Col offset={1} span={11}>
            <Card
              title={
                <a>
                  <IconText type={'arrows-alt'} text={'ORDER DETAILS'} position={'left'} />
                  <Tooltip title={'Sync Order info latest changes'}>
                    {isUpdatable && (
                      <Popconfirm
                        title="Are you sure?"
                        placement="bottom"
                        onConfirm={syncOrder}
                        okText="Yes"
                        cancelText="No">
                        <a style={{ float: 'right' }}>
                          <Icon type="sync" />
                        </a>
                      </Popconfirm>
                    )}
                  </Tooltip>
                </a>
              }>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Sales Order'}>
                  {strVal(invoice, 'order.code')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'CPO No'}>
                  {strVal(invoice, 'cpo.no')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'CPO Date'}>
                  {dateFormat(dateVal(invoice, 'cpo.date'))}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Quotation No'}>
                  {strVal(invoice, 'quote.code')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Quotation Date'}>
                  {dateFormat(dateVal(invoice, 'quote.date'))}
                </Form.Item>
              </Col>
            </Card>
          </Col>
          )}
          {/*<Col offset={1} span={11}>
            <Card title={<a>Order Details</a>}>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'CPO No'}>
                  {strVal(invoice, 'cpo.no')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'CPO Date'}>
                  {dateFormat(dateVal(invoice, 'cpo.date'))}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Quotation No'}>
                  {strVal(invoice, 'quotation.code')}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item {...formItemLayout} label={'Quotation Date'}>
                  {dateFormat(dateVal(invoice, 'quotation.date'))}
                </Form.Item>
              </Col>
            </Card>
          </Col>*/}
        </Row>
      </Form>
    )
  }
}

Overview.propTypes = {}
Overview.defaultProps = {}

export default Overview
